import { FormHelperText, InputBase, styled } from '@mui/material';

export const InputField = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== 'hasError' && prop !== 'hasValue',
})<{ hasError: boolean; value: string }>(({ theme, hasError, value }) => ({
  '&.MuiInputBase-root': {
    background: theme.palette.box.quaternary,
    borderRadius: '10px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: hasError
      ? theme.palette.border.error
      : value
        ? theme.palette.border.primary
        : 'transparent',
    '&:focus-within': {
      borderColor: hasError
        ? theme.palette.border.error
        : theme.palette.border.primary,
    },
  },
  '& .MuiInputBase-input': {
    color: theme.palette.primary.main,
    textAlign: 'center',
    fontSize: theme.typography.h2.fontSize,
    height: 'auto',
    padding: theme.spacing(6, 7),
  },
}));

export const FormErrorText = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.text.error,
  fontSize: theme.typography.textSm.fontSize,
  marginTop: theme.spacing(7),
  textAlign: 'center',
  minHeight: '20px',
}));
